import React from "react";
import WhyChooseUs from "./techInstitute/WhyChooseUs";
import OurCourses from "./techInstitute/OurCourses";
import NeedHelpSection from "./techInstitute/NeedHelpSection";
import GetInTouch from "./techInstitute/GetInTouch";
// import ContactForm from "./techInstitute/ContactForm";
// import Footer from "./techInstitute/Footer";
import AboutUs from "./techInstitute/AboutUs";
import HeroSection from "./techInstitute/HeroSection";
import Contact from "./contact/Contact";
import Footer from "../layout/footer/Footer";
import ContactForm from "./techInstitute/ContactForm";

const TechInstitute = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <AboutUs />
      <WhyChooseUs />
      <OurCourses />
      <NeedHelpSection />
      <GetInTouch />
      <ContactForm />
      <Footer />
      {/* <Contact />
      <Footer /> */}
    </div>
  );
};

export default TechInstitute;
